import { AxiosResponse } from "axios";
import Vue from "vue";
import {
  ISearchUserResponse,
  ISearchUserRequest,
  IUser,
  IUpdateUserResponse,
  IInsertUserResponse,
  IGetUserResponse,
  IGetUserRequest,
  ISetUserRolesResponse,
  ISetUserRolesRequest,
  UserRoles,
  IGetUserRolesResponse,
  IGetUserRolesRequest,
  IChangeUserEmailResponse,
  IChangeUserEmailRequest,
  IChangeUserPassResponse,
  IChangeUserPassRequest,
  IChangeUserStatusRequest,
  IChangeUserStatusResponse,
	IGetTechPricesResponse,
	IGetTechPricesRequest,
	IUpdateTechPricesResponse,
	ITechPrice,
	IUpdateTechPricesRequest
} from "@/interfaces";

export const SearchUsers = async (
  value: string,
	activeOnly: boolean,
  page: number,
  size: number
): Promise<ISearchUserResponse> => {
  const searcUsersRequest: ISearchUserRequest = {
    Page: page,
    PageSize: size,
    Keyword: value,
		ActiveOnly: activeOnly,
  };
  const resp: AxiosResponse = await Vue.axios({
    method: "POST",
    data: searcUsersRequest,
    params: {
      action: "search-users"
    }
  });
  return resp.data;
};

export const InsertUser = async (user: IUser): Promise<IInsertUserResponse> => {
  const resp: AxiosResponse = await Vue.axios({
    method: "POST",
    data: {
      User: user
    },
    params: {
      action: "insert-user"
    }
  });
  return resp.data;
};

export const UpdatedUser = async (
  user: IUser
): Promise<IUpdateUserResponse> => {
  const resp = await Vue.axios({
    method: "POST",
    data: {
      User: user
    },
    params: {
      action: "update-user"
    }
  });
  return resp.data;
};



export const UpdatedTechPrices = async (
	techID: number,
  techPrices: ITechPrice[]
): Promise<IUpdateTechPricesResponse> => {

  const req: IUpdateTechPricesRequest = {
		TechID: techID,
    TechPrices: techPrices,
  };

  const resp = await Vue.axios({
    method: "POST",
    data: req,
    params: {
      action: "update-tech-prices"
    }
  });
  return resp.data;
};



export const GetUser = async (id: number): Promise<IGetUserResponse> => {
  const getUserRequest: IGetUserRequest = {
    UserID: id
  };

  const resp: AxiosResponse = await Vue.axios({
    method: "POST",
    data: getUserRequest,
    params: {
      action: "get-user"
    }
  });
  return resp.data;
};

export const GetTechPrices = async (techID: number): Promise<IGetTechPricesResponse> => {
  const getTechPricesRequest: IGetTechPricesRequest = {
    TechID: techID
  };
  const resp: AxiosResponse = await Vue.axios({
    method: "POST",
    data: getTechPricesRequest,
    params: {
      action: "get-tech-prices"
    }
  });
  return resp.data;
};

export const SetUserRoles = async (
  id: number,
  roles: UserRoles[]
): Promise<ISetUserRolesResponse> => {
  const setUserRolesRequest: ISetUserRolesRequest = {
    UserID: id,
    Roles: roles
  };
  const resp: AxiosResponse = await Vue.axios({
    method: "POST",
    data: setUserRolesRequest,
    params: {
      action: "set-roles"
    }
  });
  return resp.data;
};

export const GetUserRoles = async (
  id: number
): Promise<IGetUserRolesResponse> => {
  const getUserRolesRequest: IGetUserRolesRequest = {
    UserID: id
  };
  const resp: AxiosResponse = await Vue.axios({
    method: "POST",
    data: getUserRolesRequest,
    params: {
      action: "get-roles"
    }
  });
  return resp.data;
};

export const ChangeUserEmail = async (
  id: number,
  email: string
): Promise<IChangeUserEmailResponse> => {
  const changeEmailRequest: IChangeUserEmailRequest = {
    UserID: id,
    NewEmail: email
  };
  const resp: AxiosResponse = await Vue.axios({
    method: "POST",
    data: changeEmailRequest,
    params: {
      action: "change-email"
    }
  });
  return resp.data;
};

export const ChangePass = async (
  id: number,
  pass1: string,
  pass2: string
): Promise<IChangeUserPassResponse> => {
  const changePassRequest: IChangeUserPassRequest = {
    UserID: id,
    CurrPass: pass1,
    NewPass: pass2
  };
  const resp: AxiosResponse = await Vue.axios({
    method: "POST",
    data: changePassRequest,
    params: {
      action: "change-pass"
    }
  });
  return resp.data;
};

export const ChangeUserStatus = async (
  id: number,
  isActive: boolean
): Promise<IChangeUserStatusResponse> => {
  const changeUserRequest: IChangeUserStatusRequest = {
    UserID: id,
    IsActive: isActive
  };
  const resp: AxiosResponse = await Vue.axios({
    method: "POST",
    data: changeUserRequest,
    params: {
      action: "change-status"
    }
  });
  return resp.data;
};
